import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useDtpModel } from "../dtpModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { IDtpDetail } from "../dtpTypes";
import { momentFormat } from "@/utils/utils";


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, loading,
        loadData, setSelectedRowKeys,
    } = useDtpModel();
    const { getTreeNodeName } = useDictModel(() => []);

    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<IDtpDetail> = [
        {
            title: '序号',
            width: 40,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '文件编号',
            width: 160,
            dataIndex: 'code',
            fixed: "left",
        }, {
            title: '状态',
            width: 120,
            dataIndex: 'status',
            render: v => v === 0 ? '已登记' : '已作废'
        }, {
            title: '销售实体',
            width: 160,
            ellipsis: true,
            dataIndex: 'shopName',
        }, {
            title: '文件类型',
            width: 120,
            dataIndex: 'agreementType',
            render: text => getTreeNodeName(text)
        }, {
            title: '合作方',
            width: 120,
            dataIndex: 'partner',
        }, {
            title: '签订日期',
            width: 180,
            dataIndex: 'signingTime',
        }, {
            title: '到期日期',
            width: 180,
            dataIndex: 'expireTime',
        }, {
            title: '创建人',
            width: 100,
            dataIndex: "createUser"
        }, {
            title: '创建日期',
            width: 180,
            dataIndex: "createTime",
            render: v => momentFormat(v as string)
        }, {
            title: '更新时间',
            width: 180,
            dataIndex: "updateTime",
            render: v => momentFormat(v as string)
        }, {
            title: '备注',
            width: 160,
            ellipsis: true,
            dataIndex: 'note',
        },
    ];


    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            rowKey={record => record.id}
            loading={loading}
            rowSelection={{
                //全部选中时  (存string[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map(item => item.id);
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                        : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                },
                onSelect: (record) => onRow(record.id),
                selectedRowKeys: selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
        />
    )
}
